module.exports = __webpack_public_path__ + "static/media/one.8b357f85.svg";